import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import api from '../../../api/api';
import { money } from '../../../client/ClientReturn';

export default function DealReturnNotice({ dealId, onReturn }) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    setInfo(null);
    if (!dealId || dealId === 'new') return;
    let active = true;
    const refresh = async () => {
      try { const res = await api.get(`/client-returns/staff/deals/${dealId}`, { skipLoading: true }); if (active) setInfo(res.data); }
      catch { /* The ordinary deal loader handles access errors; retry status later. */ }
    };
    refresh(); const timer = setInterval(refresh, 5000);
    return () => { active = false; clearInterval(timer); };
  }, [dealId]);
  if (!info) return null;
  if (Array.isArray(info)) return <>{info.map(item => <Notice key={item.id} info={item} onReturn={onReturn} />)}</>;
  return <Notice info={info} onReturn={onReturn} />;
}

function Notice({ info, onReturn }) {
  const labels = { requested: 'Клиент оставил заявку на возврат', received: 'Вещь принята на проверку', refund_pending: 'Вещь возвращена · возврат денег обрабатывается', completed: 'Возврат завершён' };
  return <Alert severity={info.status === 'completed' ? 'success' : 'info'} sx={{ m: 2 }}>
    <Typography fontWeight={700}>{info.bank_status === 'awaiting_staff' ? 'Вещь возвращена · оформите возврат денег в блоке оплат' : labels[info.status]}</Typography>
    <Typography variant="body2">{info.asset_name} · оплачено {money(info.settlement.paid)} · использование {money(info.settlement.usage_cost)} · {info.settlement.debt > 0 ? `к доплате ${money(info.settlement.debt)}` : `к возврату ${money(info.settlement.refund)}`}{info.status === 'requested' ? ' (предварительно)' : ''}.</Typography>
    {info.received_at && <Typography variant="body2">Фактически сдано: {new Date(info.received_at).toLocaleString('ru-RU')}. Время проверки не начисляется.</Typography>}
    <Typography variant="caption">{info.provider === 'ozon' ? 'Выплата и статус банка — в блоке «Оплаты, возвраты и кассовые чеки».' : info.provider === 'manual' ? 'Возврат денег оформляется сотрудником отдельно.' : 'Возврат денег тестовый, без банковского перевода.'}</Typography>
    {['requested', 'received'].includes(info.status) && <Box sx={{ mt: 1 }}><Button variant="outlined" onClick={() => onReturn(info.asset_id)}>{info.status === 'received' ? 'Завершить возврат вещи' : 'Оформить возврат вещи'}</Button></Box>}
  </Alert>;
}
